import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import GlobalStyle from './GlobalStyle';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaEye } from "react-icons/fa";

const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 5px;
  box-sizing: border-box;
`;

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
`;

const TableWrapper = styled.div`
 width: 100%;
 overflow-x: auto;
`;

const TopButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
`;

const Input = styled.input`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  flex: 1;
  min-width: 200px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fdfdfd;
  table-layout: fixed;
`;

const Th = styled.th`
  background-color: #f1f3f5;
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap;
`;

const Td = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TdStyled = styled.td`
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 14px;
  text-align: center;
  position: relative;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

.tooltip-custom {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  margin-top: 4px;
}
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const DriverColorDot = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => props.color || '#ccc'};
  margin-right: 8px;
  vertical-align: middle;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  max-width: 500px;
  max-height: 70vh;
  overflow-y: auto;
  border-radius: 8px;
`;


const CreateOrder = () => {
const [pagatoFilter, setPagatoFilter] = useState("");
const [esportatoFilter, setEsportatoFilter] = useState("");
const [tipoCliente, setTipoCliente] = useState("privato");
// Calculate total
const calculateTotal = () => {
  return selectedProducts.reduce((sum, prod) => {
    const prezzoIvato = parseFloat(calcolaPrezzoConIva(prod.selectedSalePrice, prod.iva, tipoCliente));
    const qty = parseFloat(prod.quantity || 0);
    return sum + (isNaN(prezzoIvato) || isNaN(qty) ? 0 : prezzoIvato * qty);
  }, 0);
};

const calcolaPrezzoConIva = (prezzo, iva, tipoCliente) => {
  const cleanPrezzo = parseFloat(String(prezzo).replace(/[^\d.,-]/g, '').replace(',', '.'));
  const ivaPercent = parseFloat(iva || '0');
  if (isNaN(cleanPrezzo)) return 0;
  // privato, il prezzo è già ivato
  if (tipoCliente === "privato") {
    return cleanPrezzo.toFixed(2);
  }
  // azienda, applica IVA
  if (isNaN(ivaPercent)) return cleanPrezzo.toFixed(2);
  return (cleanPrezzo * (1 + ivaPercent / 100)).toFixed(2);
};

const calcolaPrezzoUnitarioRiga = (prezzo) => {
  const cleanPrezzo = parseFloat(
    String(prezzo).replace(/[^\d.,-]/g, '').replace(',', '.')
  );
  return isNaN(cleanPrezzo) ? 0 : cleanPrezzo.toFixed(2);
};


const [orders, setOrders] = useState([]);
const [modalOpen, setModalOpen] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
const [customerFilter, setCustomerFilter] = useState("");
const [dateFilter, setDateFilter] = useState("");
const [selectedProducts, setSelectedProducts] = useState([]); // array vuoto
const [sedeFilter, setSedeFilter] = useState("");
const [searchFilter, setSearchFilter] = useState("");
const [tooltipData, setTooltipData] = useState({ value: '', visible: false, x: 0, y: 0 });
const ordersPerPage = 20;
const navigate = useNavigate();

// Tooltip
const TdWithTooltip = ({ children, tooltip }) => {
const [show, setShow] = useState(false);
  return (
    <TdStyled
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <span className="truncate block">{children}</span>
      {show && (
        <div className="tooltip-custom">
          {tooltip}
        </div>
      )}
    </TdStyled>
  );
};
//

// Gestione click
const handleCellClick = (event, value) => {
 const rect = event.currentTarget.getBoundingClientRect();
 setTooltipData({
  value,
  visible: true,
  x: rect.left + window.scrollX,
  y: rect.bottom + window.scrollY,
 });
};


// GET corrispettivi
useEffect(() => {
 axios
  .get("/api/corrs")
  .then((response) => { if (Array.isArray(response.data)) { setOrders(response.data); } })
      .catch((error) => { console.error("Error fetching orders:", error); });
  }, []
);
// #######################

// Modale ##################
const [selectedOrderId, setSelectedOrderId] = useState("");
const openProductsModal = (orderId) => {
  setSelectedOrderId(orderId);
  // prima recupera tipoCliente
  const encodedOrderId = encodeURIComponent(orderId);
  axios.get(`/api/corrs/${encodedOrderId}`)
    .then((response) => {
      if (response.data && response.data.tipoCliente) {
        setTipoCliente(response.data.tipoCliente);
      }
    })
    .catch((error) => {
      console.error("Errore nel recuperare ordine:", error);
      setTipoCliente("privato"); // fallback
    })
    .finally(() => {
      // poi recupera i prodotti
      axios.get(`/api/corrs/${encodedOrderId}/products`)
        .then((response) => {
          if (Array.isArray(response.data)) {
            setSelectedProducts(response.data);
          } else {
            setSelectedProducts([]);
          }
          setModalOpen(true);
        })
        .catch((error) => {
          console.error("Errore nel recuperare prodotti:", error);
          setSelectedProducts([]);
          setModalOpen(true);
        });
    });
};

const closeModal = () => {
    setModalOpen(false);
    setSelectedProducts([]);
  };
// ##########################

// Filtri, paginazione, etc...
const filteredOrders = orders.filter((ord) => {
const orderId = ord.orderId.toLowerCase();
const pagato = ord.pagato?.toString().toLowerCase() || "";
const esportato = ord.esportato?.toString().toLowerCase() || "";
const autista = ord.autista?.toLowerCase() || "";
const stato = ord.status?.toLowerCase() || "";
const searchMatch = searchFilter ? orderId.includes(searchFilter.toLowerCase()) : true;
const pagatoMatch = pagatoFilter ? pagato.includes(pagatoFilter.toLowerCase()) : true;
const esportatoMatch = esportatoFilter ? esportato.includes(esportatoFilter.toLowerCase()) : true;

return searchMatch && pagatoMatch && esportatoMatch;
});
const indexOfLastOrder = currentPage * ordersPerPage;
const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);
const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);
// ##########################################

// Create new corrispettivo
const handleCreateNewOrder = () => {
 function generateOrderId() {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, "0");
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const yy = String(now.getFullYear()).slice(-2);
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
   return `ORD_${dd}-${mm}-${yy}-${hh}-${min}`;
 }
  const newOrderId = generateOrderId();
   navigate(`/add-corr/${newOrderId}`);
  };
  const handleManageOrders = () => {
    navigate("/corrsedit");
  };

{tooltipData.visible && (
  <div
    id="order-tooltip"
    style={{
      position: 'absolute',
      top: tooltipData.y,
      left: tooltipData.x,
      background: '#333',
      color: '#fff',
      padding: '6px 10px',
      borderRadius: '6px',
      zIndex: 9999,
      maxWidth: '300px',
      pointerEvents: 'auto',
      userSelect: 'none',
    }}
    onClick={() => setTooltipData({ ...tooltipData, visible: false })}
  >
    {tooltipData.value}
  </div>
)}
// ################

// Gestione tooltip nome intero corrispettivo on click
useEffect(() => {
  function handleClickOutside(event) {
    if (!tooltipData.visible) return;
    const tooltipElement = document.getElementById('order-tooltip');
    if (
      tooltipElement &&
      !tooltipElement.contains(event.target) &&
      !event.target.classList.contains('order-cell')
    ) {
      setTooltipData({ ...tooltipData, visible: false });
    }
  }
  document.addEventListener('click', handleClickOutside);
  return () => {
    document.removeEventListener('click', handleClickOutside);
  };
}, [tooltipData]);
// ######################################################

// DOWNLOAD PDF
const handleDownloadPDF = () => {
  if (!selectedProducts.length) return;
  const doc = new jsPDF();
  const orderId = selectedProducts[0]?.orderId || 'ordine';
  const first = selectedProducts[0];
  doc.setFontSize(16);
  doc.text(`Corrispettivo ${selectedOrderId}`, 14, 20);
  doc.setFontSize(12);

const tableData = selectedProducts.map((prod, idx) => {
  const prezzoUnitario = calcolaPrezzoUnitarioRiga(prod.selectedSalePrice);
  const prezzoParziale = (
    parseFloat(prod.quantity || 0) * parseFloat(prezzoUnitario)
  ).toFixed(2);
  return [
    idx + 1,
    prod.productName,
    prod.quantity,
    prod.unit,
    `${prezzoUnitario} €`,
    `${prezzoParziale} €`,
  ];
});

  const totalBase = selectedProducts.reduce((acc, prod) => {
  const prezzoUnit = parseFloat(calcolaPrezzoUnitarioRiga(prod.selectedSalePrice));
  return acc + prezzoUnit * parseFloat(prod.quantity || 0);
}, 0);

const total = tipoCliente === "azienda"
  ? (totalBase * (1 + (parseFloat(selectedProducts[0]?.iva || 0) / 100)))
  : totalBase;

  tableData.push([
    '',
    'Totale',
    '',
    '',
    '',
    total.toFixed(2) + ' €',
  ]);

  doc.autoTable({
    startY: 30,
    head: [['#', 'Prodotto', 'Quantità', 'UM', 'Prezzo unitario', 'Prezzo parziale']],
    body: tableData,
  });

  doc.save(`corrispettivo_${selectedOrderId}.pdf`);
};


// RETURN
  return (
    <>
      <GlobalStyle />
      <PageContainer>
      <Content>
        <TopButtons>
          <Button onClick={handleCreateNewOrder}>Crea Corr.</Button>
          <Button onClick={handleManageOrders}>Gestisci Corr.</Button>
        </TopButtons>

<FiltersContainer>
  <Input
    type="text"
    placeholder="Filtra cliente / Data Corrispettivo"
    value={searchFilter}
    onChange={(e) => {
      setSearchFilter(e.target.value);
      setCurrentPage(1);
    }}
  />
 <Input
   type="text"
   placeholder="Filtra per pagato"
   value={pagatoFilter}
   onChange={(e) => {
     setPagatoFilter(e.target.value);
     setCurrentPage(1);
   }}
 />
 <Input
   type="text"
   placeholder="Filtra per esportato"
   value={esportatoFilter}
   onChange={(e) => {
     setEsportatoFilter(e.target.value);
     setCurrentPage(1);
   }}
 />
</FiltersContainer>


     <TableWrapper>
        <Table>
<thead>
  <tr>
    <Th>Cliente e data</Th>
    <Th style={{ width: '90px' }}>Pagato</Th>
    <Th style={{ width: '90px' }}>Esportato</Th>
    <Th>Prodotti</Th>
  </tr>
</thead>
 <tbody>
  {currentOrders.length > 0 ? (
    currentOrders.map((ord) => (
      <tr key={ord.orderId}>
        <Td
          className="order-cell"
          style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            border: '1px solid #ccc',
            cursor: 'pointer',
          }}
          onClick={(e) => handleCellClick(e, ord.orderId)}
        >
          {ord.orderId}
        </Td>
        <Td>{ord.pagato ? `${ord.pagato} ` : '—'}</Td>
	<Td>{ord.esportato ? `${ord.esportato}` : '—'}</Td>
	<Td>
      <Button onClick={() => openProductsModal(ord.orderId)}>
      {window.innerWidth <= 768 ? <FaEye /> : "Visualizza prodotti"}
      </Button>
      </Td>
      </tr>
    ))
    ) : (
    <tr>
      <Td colSpan="4">Nessun ordine trovato.</Td>
    </tr>
     )}
      </tbody>
        </Table>
         {tooltipData.visible && (
            <div
              style={{
                position: 'absolute',
                top: tooltipData.y,
                left: tooltipData.x,
                background: '#333',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: '6px',
                zIndex: 9999,
                maxWidth: '300px',
                pointerEvents: 'auto', // per permettere il click su tooltip
                userSelect: 'none',
              }}
              onClick={() => setTooltipData({ ...tooltipData, visible: false })}
            >
              {tooltipData.value}
            </div>
          )}
    </TableWrapper>
      {modalOpen && ( <ModalOverlay onClick={closeModal}>
       <ModalContent onClick={(e) => e.stopPropagation()}> <h4>Corrispettivo {selectedOrderId} </h4>
       {selectedProducts.length > 0 ? ( <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Prodotto</th>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>Quantità</th>
	  <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>UM</th>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>Prezzo unitario</th>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>Prezzo parziale</th>
        </tr>
      </thead>
      <tbody>
        {selectedProducts.map((prod, index) => (
          <tr key={index}>
            <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{prod.productName.trim()}</td>
            <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}>{prod.quantity}</td>
	    <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}>{prod.unit}</td>
            <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}> {tipoCliente === "azienda"
    ? calcolaPrezzoUnitarioRiga(prod.selectedSalePrice)
    : calcolaPrezzoConIva(prod.selectedSalePrice, prod.iva, tipoCliente)} €
</td> 
            <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}> {tipoCliente === "azienda"
    ? (parseFloat(prod.quantity) * parseFloat(calcolaPrezzoUnitarioRiga(prod.selectedSalePrice))).toFixed(2)
    : (parseFloat(prod.quantity) * parseFloat(calcolaPrezzoConIva(prod.selectedSalePrice, prod.iva, tipoCliente))).toFixed(2)
  } €
</td>
          </tr>
        ))}
      </tbody>
  </table>
       ) : (
       <p>Nessun prodotto disponibile.</p>
      )}
       <p style={{ fontWeight: 'bold', textAlign: 'right', marginTop: '10px' }}> Totale: {calculateTotal().toFixed(2)} € </p>
       <TopButtons> <Button onClick={handleDownloadPDF}>Scarica PDF</Button>  <Button onClick={closeModal}>Chiudi</Button> </TopButtons>
        </ModalContent>
        </ModalOverlay>
       )}
        {totalPages > 1 && (
          <Pagination>
            <Button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} > ← Precedente </Button>
            <span>Pagina {currentPage} di {totalPages}</span>
            <Button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} > Successiva → </Button>
          </Pagination>
        )}
 </Content>
</PageContainer>
</>
);
};

export default CreateOrder;
